import { render } from "./TodoItem.vue?vue&type=template&id=6c871267&scoped=true"
import script from "./TodoItem.vue?vue&type=script&lang=js"
export * from "./TodoItem.vue?vue&type=script&lang=js"

import "./TodoItem.vue?vue&type=style&index=0&id=6c871267&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c871267"

export default script